import { Container } from '@mantine/core';
import { useAppUser } from '../../hooks/useAppUser';
import { usePageTitle } from '../../hooks/usePageTitle';
import { ExternalSourcesPanel } from '../../components/Admin/ExternalSourcesPanel';

export const AdminImportsPage = () => {
  usePageTitle('Admin Imports | Meals You Love');
  const { user } = useAppUser();

  return (
    <Container size="xl" py="xl">
      {user && <ExternalSourcesPanel user={user} />}
    </Container>
  );
};
